import React, {PureComponent} from "react"
import QRCode from "qrcode.react"
import {InjectIntl, injectIntl} from "@irati/utils/lang"
import StockType from "@irati/stock/enums/StockType"

import ValueLabel from "./ValueLabel"
import {ProductCode, CodeWrapper, QRCodeWrapper, StyledLink} from "./styled"

interface Props extends InjectIntl {
  redemption?: RewardRedemption
}

class Code extends PureComponent<Props> {
  static defaultProps = {
    redemption: undefined
  }

  render() {
    const {redemption, formatMessage} = this.props
    if (!redemption || !redemption.stock) return null

    switch (redemption.stock.type) {
      case StockType.QR:
        return (
          <QRCodeWrapper>
            <QRCode value={redemption.stock.code} size={240} />
          </QRCodeWrapper>
        )
      case StockType.URL:
        return (
          <CodeWrapper>
            <ValueLabel label={formatMessage({id: "recognition.account.rewards.url"})} />
            <StyledLink href={redemption.stock.code} target="_blank">
              {redemption.stock.code}
            </StyledLink>
          </CodeWrapper>
        )
      default:
        return (
          <CodeWrapper>
            <ValueLabel label={formatMessage({id: "recognition.account.rewards.discountCode"})} />
            <ProductCode>{redemption.stock.code}</ProductCode>
          </CodeWrapper>
        )
    }
  }
}

export default injectIntl(Code)
